<template>
  <div class="Introduce">
    <div class="product_top flex_row">
      <div class="left">
        <el-carousel  width="100%" arrow="always" @change="changeCarousel" ref="carousel"  :height="imgHeight">
          <el-carousel-item v-for="(item, index) in listSrc" :key="index">
              <img ref="imgH" :src="item" alt="" style="width: 100%">
          </el-carousel-item>
          <div class="left_search flex_row" @click="searchClick">
            <img src="@/assets/img/introduce_search.png">
          </div>
        </el-carousel>
        <div class="small_Img flex_row" @click="setActiveItem">
          <div class="img_border flex_row" v-for="(item, index) in listSrc" :key="index">
            <img :src="item" alt="" :data-index="index" :class="carouselIndex==index?'pattern': ''">
          </div>
        </div>
      </div>
    </div>
    <el-dialog class="dialog" :visible.sync="dialogTableVisible" style="width: 100vw; height: 100vh">
      <img :src="imgSrc" alt="" style="width: 100%">
    </el-dialog>
  </div>
</template>

<script>
import {Loading, MessageBox} from "element-ui";
import axios from "@/axios/axios";
import store from "@/store";
export default {
  name: 'Introduce',
  data() {
    return {
      imgHeight: '0',
      carouselIndex: 0,
      getRelationListResult: {},
      ProductDetail: {},
      Brand: {},
      Product: {},
      ProductNum: 1,
      CHPChooseId: '',
      CHPProductId: '',
      activeName: 'first',
      dialogTableVisible: false,
      imgSrc: '',
      listSrc: [],
      interval: null
    }
  },
  created() {
    this.imgLoad();
    let key = this.$route.query.key;
    let list = [
      {
        srcArr: ['https://ow.visumall.com/public/img/pc/pc_equipment11.jpg'],
      },
      {
        srcArr: ['https://ow.visumall.com/public/img/pc/pc_equipment21.jpg','https://ow.visumall.com/public/img/pc/pc_equipment22.jpg','https://ow.visumall.com/public/img/pc/pc_equipment23.jpg','https://ow.visumall.com/public/img/pc/pc_equipment24.jpg'],
      },
      {
        srcArr: ['https://ow.visumall.com/public/img/pc/pc_equipment31.jpg'],
      },
      {
        srcArr: ['https://ow.visumall.com/public/img/pc/pc_equipment41.jpg'],
      },
      {
        srcArr: ['https://ow.visumall.com/public/img/pc/pc_equipment51.jpg'],
      },
      {
        srcArr: ['https://ow.visumall.com/public/img/pc/pc_equipment61.jpg','https://ow.visumall.com/public/img/pc/pc_equipment62.jpg','https://ow.visumall.com/public/img/pc/pc_equipment63.jpg','https://ow.visumall.com/public/img/pc/pc_equipment64.jpg'],
      },
    ];
    this.listSrc = list[key - 1].srcArr;
    this.imgSrc = this.listSrc[0]
  },
  mounted() {
    this.clear();
    this.interval = setInterval(this.imgLoad, 1000)
  },
  destroyed() {
    this.clear();
  },
  methods: {
    clear() {
      if(this.interval) {
        clearInterval(this.interval)
      }
    },
    imgLoad(){
      this.$nextTick(()=>{
        let imgHeight = `${this.$refs.imgH[0].height}px`;
        if(imgHeight == '0px') {
          imgHeight = '70vh'
        }
        else {
          clearInterval(this.interval)
        }
        this.imgHeight = imgHeight;
      })
    },
    changeCarousel(e) {
      if(!this.dialogTableVisible)
        this.imgSrc = this.listSrc[e];
      this.carouselIndex = e;
    },
    setActiveItem(e) {
      let index = e.target.dataset.index;
      this.carouselIndex = index;
      this.$refs.carousel.setActiveItem(index);
    },
    searchClick() {
      this.dialogTableVisible = true;
    }
  }
}
</script>

<style scoped lang="scss">
.Introduce {
  min-width: 1024px;
  width: 70vw;
  margin: 0 auto;
  .product_top {
    align-items: flex-start;
    .left {
      width: 70%;
      //.big_Img {
      //  width: 100%;
      //  height: 100%;
      //}
      .small_Img {
        width: 100%;
        flex-wrap: wrap;;
        overflow: hidden;
        overflow-x: auto;
        list-style: none;
        .img_border {
          margin-top: 0.35rem;
          width: 25%;
          img {
            width: 80%;
            border: 0.01rem solid #BCBCBC;
          }
          .pattern {
            border: 0.01rem solid red;
          }
        }
      }
      .el-carousel {
        border: 0.01rem solid #BCBCBC;
        position: relative;
        //::v-deep .el-carousel__container {
        //  height: 60vh;
        //}
        ::v-deep .el-carousel__indicators {// 指示器
          display: none;
        }
        ::v-deep .el-carousel__arrow {
          background-color: rgba(31,45,61,0);
          color: #010101;
          font-size: 0.22rem;
        }
        ::v-deep .el-carousel__arrow--left {
          left: 0;
          opacity: 0.67;
        }
        ::v-deep .el-carousel__arrow--right {
          right: 0;
          opacity: 0.67;
        }
      }

      .left_search {
        width: 1rem;
        height: 1rem;
        left: 100%;
        top: 100%;
        z-index: 999;
        transform: translate(-120%, -120%);
        position: absolute;
        img {
          width: 50%;
        }
      }
    }
  }
  .dialog {
    ::v-deep .el-dialog {
      margin-top: 3vh!important;
      width: 78%;
    }
  }
}
</style>
